import Vue from 'vue'
import Router from 'vue-router'
// 静态页面
import Payment from '@/components/PaymentAgreement' // 付费协议
import Vip from '@/screens/vip/index' // VIP介绍
// 业务模块
const Stu = () => import('@/components/Stu/App') // 学生入口
const linshi = () => import('@/components/Stu/AppLinshi') // 学生入口
const StuMain = () => import('@/components/Stu/StuMain/App') // 首页 框
const StuIndex = () => import('@/components/Stu/StuIndex/App') // 首页
const StuExamDetail = () => import('@/components/Stu/StuExamDetail/App') // 测评详情
const StuDetection = () => import('@/components/Stu/StuDetection/App') // 设备检测
const StuPractice = () => import('@/components/Stu/StuPractice/App') // 测评 练习
const StuWork = () => import('@/components/Stu/StuPractice/StuWork/App') // 练习
const WorkDetailList = () => import('@/components/Stu/WorkDetailList/App')

// const StuTask = () => import('@/components/Stu/StuPractice/StuTask/App') // 非VIP练习
const StuExam = () => import('@/components/Stu/StuPractice/StuExam/App') // 测评
const StuAggregate = () => import('@/components/Stu/StuAggregate/App') // 错题本
const StuAggregateMain = () => import('@/components/Stu/StuAggregate/StuMain/App') // 错题本
const StuCollection = () => import('@/components/Stu/StuCollection/App') // 收藏本
const StuCollectionMain = () => import('@/components/Stu/StuCollection/StuMain/App') // 收藏本
const StuPhonetics = () => import('@/components/Stu/StuPhonetics/App') // 音标学习
const StuTSKS = () => import('@/components/Stu/StuTSKS/App') // 听说考试
const StuSpecial = () => import('@/components/Stu/StuSpecial/App') // 专项训练
const StuTopics = () => import('@/components/Stu/StuTopics/App') // 话题项目
const StuSTS = () => import('@/components/Stu/StuSTS/App') // 视听说
const StuShzgs = () => import('@/components/Stu/StuShzgs/App')
const StuDialogue = () => import('@/components/Stu/StuDialogue/App') // 情景对话
const StuComposition = () => import('@/components/Stu/StuComposition/App') // 口头作文
const StuTrends = () => import('@/components/Stu/StuTrends/App') // 班级动态
const StuSync = () => import('@/components/Stu/StuSync/App') // 同步练习
const StuTbcp = () => import('@/components/Stu/StuTbcp/App') // 同步练习

// const StuSync = () => import('@/components/Stu/queueUp/app') // 假期作业列表

const StuRecord = () => import('@/components/Stu/StuRecord/App') // 学习记录
const StuBible = () => import('@/components/Stu/StuBible/App') // 听说宝典列表
const StuBibleDetail = () => import('@/components/Stu/StuBible/Detail') // 听说宝典详情
// const StuMsgCenter = () => import('@/components/Stu/StuMsgCenter/App') // 消息中心列表
const StuMsgDetail = () => import('@/components/Stu/StuMsgCenter/Detail') // 消息中心详细
const StuOwnInfo = () => import('@/components/Stu/StuOwnInfo/App') // 个人资料
const StuHelp = () => import('@/components/Stu/StuHelp/App') // 在线帮助
const ExamPaper = () => import('@/components/Stu/StuExamPaper/App') // 自学试卷包
const StuBook = () => import('@/components/Stu/StuBook/App') // 我的图书
const report = () => import('@/components/Stu/StuPractice/StuExam/reportv2') // 测评非vip报告
const workReport = () => import('@/components/Stu/StuPractice/StuWork/workReport2') // 测评
const homeWorkList = () => import('@/components/Stu/StuIndex/homeWorkList') // 假期作业列表
// 教师当学生用
const TStuIndex = () => import('@/components/Stu/TStuIndex/App') // 首页
const TIntro = () => import('@/components/Stu/TIntro/App') // 专题培训
const TTrain = () => import('@/components/Stu/TTrain/App') // 专题培训
const TTrainDetail = () => import('@/components/Stu/TTrain/TTrainDetail') // 专题介绍
const TTrainMain = () => import('@/components/Stu/TTrain/main') // 专题培训主页
const TTrainVideo = () => import('@/components/Stu/TTrain/video') // 专题培训视频
const edit = () => import('@/components/Stu/TTrain/edit')
Vue.use(Router)

const _t2s = localStorage.getItem('t2s')
let _home = [{ path: '', redirect: 'index' }]

if (_t2s) _home.push({ path: 'index', name: 'stuIndex', component: TStuIndex })
else _home.push({ path: 'index', name: 'stuIndex', component: StuIndex })

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/phonetics',
      name: 'Phonetics',
      component: StuPhonetics
    },
    {
      path: '/linshiphonetics',
      name: 'linshiphonetics',
      component: StuPhonetics
    },
    {
      path: '/detection',
      name: 'detection',
      component: StuDetection
    },
    {
      path: '/practice',
      name: 'practice',
      component: StuPractice,
      children: [
        { path: 'work', name: 'work', component: StuWork },
        // { path: 'task', name: 'task', component: StuWork },
        { path: 'exam', name: 'exam', component: StuExam },
        { path: 'report', name: 'report', component: report },
        { path: 'workReport', name: 'workReport', component: workReport }
      ]
    },
    {
      path: '/stu',
      component: Stu,
      children: [
        { path: '', redirect: 'home' },
        {
          path: 'home',
          component: StuMain,
          children: [].concat(_home, [
            { path: '', redirect: 'index' },
            { path: 'workDetailList', name: 'WorkDetailList', component: WorkDetailList },
            { path: 'examDetail', name: 'stuExamDetail', component: StuExamDetail },
            {
              path: 'aggregate',
              name: 'stuAggregate',
              component: StuAggregate,
              children: [
                {
                  path: 'StuAggregateMain',
                  name: 'StuAggregateMain',
                  component: StuAggregateMain
                }
              ]
            },
            {
              path: 'collection',
              name: 'stuCollection',
              component: StuCollection,
              children: [
                {
                  path: 'StuCollectionMain',
                  name: 'StuCollectionMain',
                  component: StuCollectionMain
                }
              ]
            },
            { path: 'tsks', name: 'stuTSKS', component: StuTSKS },
            { path: 'special', name: 'stuSpecial', component: StuSpecial },
            { path: 'topics', name: 'stuTopics', component: StuTopics },
            { path: 'sts', name: 'stuSTS', component: StuSTS },
            { path: 'dialogue', name: 'stuDialogue', component: StuDialogue },
            { path: 'composition', name: 'stuComposition', component: StuComposition },
            { path: 'trends', name: 'stuTrends', component: StuTrends },
            { path: 'tintro', name: 'tintro', component: TIntro }, // 教研 介绍详情
            { path: 'homeWorkList', name: 'homeWorkList', component: homeWorkList },
            {
              path: 'bible',
              name: 'stuBible',
              component: StuBible
            },
            {
              path: 'bible/detail/:id',
              name: 'stuBibleDetail',
              component: StuBibleDetail
            }
          ])
        },
        {
          path: 'tbcp',
          name: 'stuTbcp',
          component: StuTbcp
        },
        {
          path: 'sync',
          name: 'stuSync',
          component: StuSync
        },
        {
          path: 'shzgs',
          name: 'stuShzgs',
          component: StuShzgs
        },
        {
          path: 'book',
          name: 'stuBook',
          component: StuBook
        },
        {
          path: 'record',
          name: 'stuRecord',
          component: StuRecord
        },
        // {
        //   path: 'bible',
        //   name: 'stuBible',
        //   component: StuBible
        // },
        // { path: 'bible/detail/:id', name: 'stuBibleDetail', component: StuBibleDetail },
        // { path: 'msgCenter', name: 'stuMsgCenter', component: StuMsgCenter },
        { path: 'ownInfo', name: 'stuOwnInfo', component: StuOwnInfo },
        { path: 'ownInfo/detail', name: 'stuMsgDetail', component: StuMsgDetail },
        { path: 'help', name: 'stuHelp', component: StuHelp },
        { path: 'examPaper', name: 'ExamPaper', component: ExamPaper },
        { path: 'vip', name: 'vip', component: Vip },
        /*
         * 教师当学生用
         */
        {
          path: 'TTrain',
          component: TTrain,
          children: [
            { path: '', redirect: 'TTrainMain' },
            { path: 'TTrainMain', name: 'TTrainMain', component: TTrainMain },
            { path: 'TTrainDetail', name: 'TTrainDetail', component: TTrainDetail },
            { path: 'edit', name: 'edit', component: edit }
          ]
        },
        { path: 'Tspecial', name: 'TstuSpecial', component: StuSpecial },
        { path: 'Ttsks', name: 'TstuTSKS', component: StuTSKS }
      ]
    },
    {
      path: '/linshi',
      component: linshi,
      children: [
        { path: '', redirect: 'home' },
        {
          path: 'home',
          component: StuMain,
          children: [
            { path: '', redirect: 'tsks' },
            { path: 'index', redirect: 'tsks' },
            { path: 'workDetailList', name: 'WorkDetailList', component: WorkDetailList },
            { path: 'examDetail', name: 'stuExamDetail', component: StuExamDetail },
            {
              path: 'aggregate',
              name: 'stuAggregate',
              component: StuAggregate,
              children: [
                {
                  path: 'StuAggregateMain',
                  name: 'StuAggregateMain',
                  component: StuAggregateMain
                }
              ]
            },
            {
              path: 'collection',
              name: 'stuCollection',
              component: StuCollection,
              children: [
                {
                  path: 'StuCollectionMain',
                  name: 'StuCollectionMain',
                  component: StuCollectionMain
                }
              ]
            },
            { path: 'tsks', name: 'stuTSKS', component: StuTSKS },
            { path: 'special', name: 'stuSpecial', component: StuSpecial },
            { path: 'topics', name: 'stuTopics', component: StuTopics },
            { path: 'sts', name: 'stuSTS', component: StuSTS },
            { path: 'dialogue', name: 'stuDialogue', component: StuDialogue },
            { path: 'composition', name: 'stuComposition', component: StuComposition },
            { path: 'trends', name: 'stuTrends', component: StuTrends },
            { path: 'tintro', name: 'tintro', component: TIntro }, // 教研 介绍详情
            { path: 'homeWorkList', name: 'homeWorkList', component: homeWorkList },
            {
              path: 'bible',
              name: 'stuBible',
              component: StuBible
            },
            {
              path: 'bible/detail/:id',
              name: 'stuBibleDetail',
              component: StuBibleDetail
            }
          ]
        },
      ]
    },
    { path: '/TTrainVideo', name: 'TTrainVideo', component: TTrainVideo },
    {
      path: '/payment',
      name: 'payment',
      component: Payment
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js